

import { Injectable } from '@angular/core';
import { ModalDialogService } from '../ui-elements/modal-dialog/modal-dialog.service';
import { AppState } from 'src/app/store/states/app.state';
import { select, Store } from '@ngrx/store';
import { map, Observable, of, switchMap, take } from 'rxjs';
import * as fromUserSelectors from '../../store/selectors/user.selector';
import { MODAL_MIN_WIDTH } from './constants';

@Injectable({ providedIn: 'root' })
export class UnsavedChangesHelper {
  public isFormDirty: boolean = false;

  constructor(private dialogService: ModalDialogService, private store$: Store<AppState>) { }

  public isFormDirtyConfirmationModal(): Observable<boolean> {
    return this.store$.pipe(
      select(fromUserSelectors.isUserAuthenticated),
      take(1),
      switchMap(isAuth => {
        if (isAuth && this.isFormDirty) {
          this.dialogService.open(
            {
              title: `settings.tab.navigation.unsavedChanges`,
              cancelTextBtn: 'general.label.no',
              confirmTextBtn: 'general.label.yes',
              confirmBtnClass: 'button-primary',
              cancelBtnClass: 'button-empty button-left-aligned ',
            },
            { minWidth: MODAL_MIN_WIDTH, autoFocus: false }
          );
          return this.dialogService.confirmed().pipe(map(confirmationResult=> {
            if (confirmationResult) {
              this.isFormDirty = false
            }
            return confirmationResult;
          }));
        }
        return of(true);
      })
    );
  }
}
